import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "mobile-top-navbar__wrapper" }
const _hoisted_2 = { class: "mobile-top-navbar__logo-wrapper" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 0,
  class: "mobile-top-navbar__logo-affiliate-wrapper"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  class: "mobile-top-navbar--partner__description-wrapper"
}
const _hoisted_7 = { class: "mobile-top-navbar--partner__description-text" }
const _hoisted_8 = {
  key: 0,
  class: "mobile-top-navbar__menu-wrapper"
}
const _hoisted_9 = { class: "mobile-top-navbar__menu-links" }
const _hoisted_10 = ["href"]
const _hoisted_11 = {
  key: 0,
  class: "mobile-top-navbar__link mobile-top-navbar__link--login",
  href: "javascript:void(0)"
}
const _hoisted_12 = {
  key: 1,
  class: "mobile-top-navbar__find-level"
}
const _hoisted_13 = { class: "mobile-top-navbar__content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PxIcon = _resolveComponent("PxIcon")!
  const _directive_touch = _resolveDirective("touch")!
  const _directive_observer = _resolveDirective("observer")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{
      'is-small': _ctx.isSmall,
      'mobile-top-navbar--affiliate': _ctx.showAffiliateLogo,
      'mobile-top-navbar--partner': _ctx.isPartner,
    }, "mobile-top-navbar"]),
    style: _normalizeStyle({ minHeight: `${_ctx.rootHeight}px` })
  }, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          src: _ctx.mainLogo,
          alt: "VIRAL Logo",
          class: "mobile-top-navbar__logo"
        }, null, 8, _hoisted_3),
        (_ctx.showAffiliateLogo)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("img", {
                src: _ctx.affiliateLogo,
                alt: "Affiliate Logo",
                class: "mobile-top-navbar__logo-affiliate"
              }, null, 8, _hoisted_5)
            ]))
          : (_ctx.isPartner)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.getPartnerName), 1)
              ]))
            : _createCommentVNode("", true)
      ]),
      (!_ctx.isPartner)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _withDirectives(_createVNode(_component_PxIcon, {
              name: `menu-hamburguer`,
              size: 24,
              class: "mobile-top-navbar__menu-open"
            }, null, 512), [
              [_directive_touch, _ctx.toggleMenu]
            ]),
            _withDirectives((_openBlock(), _createElementBlock("div", {
              ref: "mobileMenu",
              class: _normalizeClass([{
            'mobile-top-navbar__menu-overlay--active': _ctx.isMobileMenuOpen,
          }, "mobile-top-navbar__menu-overlay"])
            }, [
              _cache[0] || (_cache[0] = _createElementVNode("img", {
                alt: "abaca logo",
                class: "mobile-top-navbar__menu-logo",
                src: "/img/logos/abaca-logo--dark.svg"
              }, null, -1)),
              _createElementVNode("ul", _hoisted_9, [
                _createElementVNode("li", null, [
                  _createElementVNode("a", {
                    href: _ctx.howItWorksLink.url,
                    class: "mobile-top-navbar__link",
                    target: "_blank"
                  }, _toDisplayString(_ctx.howItWorksLink.title), 9, _hoisted_10)
                ])
              ]),
              (_ctx.isVisitorNavigation)
                ? _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_11, [
                    _createTextVNode(_toDisplayString(_ctx.$t("common.navBar.login")), 1)
                  ])), [
                    [_directive_touch, _ctx.onClickLogin]
                  ])
                : _createCommentVNode("", true),
              _withDirectives(_createVNode(_component_PxIcon, {
                name: `menu-cross`,
                size: 24,
                class: "mobile-top-navbar__menu-close"
              }, null, 512), [
                [_directive_touch, _ctx.toggleMenu]
              ])
            ], 2)), [
              [
                _directive_touch,
                _ctx.touchMobileMenuHandler,
                "start",
                {
                  end: true,
                  move: true,
                  moving: true
                }
              ]
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isToShowSubTitle)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            (_ctx.isAssessment)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_ctx.$t("selfAssessment.assessment.headerCopy")), 1)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(_ctx.$t("selfAssessment.results.headerCopy")), 1)
                ], 64))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_13, [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ])
    ])), [
      [
        _directive_observer,
        _ctx.updateNavHeight,
        "subtree",
        { childlist: true }
      ]
    ])
  ], 6))
}